exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./fonts/Lato-Reg.ttf"));
var ___CSS_LOADER_URL___1___ = urlEscape(require("./fonts/Lato-Lig.ttf"));
var ___CSS_LOADER_URL___2___ = urlEscape(require("./fonts/Lato-Bol.ttf"));

// Module
exports.push([module.id, "@font-face {\n  font-family: 'lato';\n  src: url(" + ___CSS_LOADER_URL___0___ + ") format('truetype');\n}\n\n@font-face {\n  font-family: 'lato-lig';\n  src: url(" + ___CSS_LOADER_URL___1___ + ") format('truetype');\n}\n\n@font-face {\n  font-family: 'lato-bold';\n  src: url(" + ___CSS_LOADER_URL___2___ + ") format('truetype');\n}", ""]);

